import React, { ReactElement, ReactNode } from 'react';

import './DropPlaceholders.scss';

export function TopDroppedPlaceholder(): ReactElement {
  return <div className="TopDroppedPlaceholder" />;
}

type BottomDroppedPlaceholderProps = {
  children?: ReactNode;
};

export function BottomDroppedPlaceholder({ children }: BottomDroppedPlaceholderProps): ReactElement {
  return <div className="BottomDroppedPlaceholder">{children}</div>;
}

export function BottomChildrenPlaceholder(): ReactElement {
  return <div className="BottomChildrenPlaceholder" />;
}

type BottomParentPlaceholderProps = {
  isActive: boolean;
};

export function BottomParentPlaceholder({ isActive }: BottomParentPlaceholderProps): ReactElement {
  return (
    <div
      className="BottomParentPlaceholder"
      style={{ width: isActive ? '60px' : '0', borderRight: isActive ? '4px solid white' : 'none' }}
    />
  );
}
